/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Constraint } from './constraint';
import { DynamicOperand } from './dynamicOperand';
import { StaticOperand } from './staticOperand';


export interface ComparisonConstraint extends Constraint { 
    operand1: DynamicOperand;
    operand2: StaticOperand;
    operator: ComparisonConstraint.OperatorEnum;
}
export namespace ComparisonConstraint {
    export type OperatorEnum = 'EQUALS' | 'NOT_EQUALS' | 'LESS_THAN' | 'LESS_THAN_OR_EQUAL' | 'GREATER_THAN' | 'GREATER_THAN_OR_EQUAL' | 'LIKE' | 'NOT_LIKE';
    export const OperatorEnum = {
        EQUALS: 'EQUALS' as OperatorEnum,
        NOTEQUALS: 'NOT_EQUALS' as OperatorEnum,
        LESSTHAN: 'LESS_THAN' as OperatorEnum,
        LESSTHANOREQUAL: 'LESS_THAN_OR_EQUAL' as OperatorEnum,
        GREATERTHAN: 'GREATER_THAN' as OperatorEnum,
        GREATERTHANOREQUAL: 'GREATER_THAN_OR_EQUAL' as OperatorEnum,
        LIKE: 'LIKE' as OperatorEnum,
        NOTLIKE: 'NOT_LIKE' as OperatorEnum
    };
}
